/*
 * src/components/TransferHistory/TransferDocuments.jsx
 * Description: Downloadable documentation for a particular transfer
 * Copyright (c) 2021
 */
import React from "react";

import { shouldHideDocuments } from "../../utils/validations";
import { asyncWrapper } from "../../utils/util";
import downloadPdfPromise from "../../utils/service/service_pdf-download";

const TransferDocuments = ({ documentData, transferId, status }) => {
  const escrowAgreements = documentData.filter(
    (f) => f?.transfer?.id === transferId && f.type === "escrow agreement"
  );
  const receipts = documentData.filter(
    (f) => f?.transfer?.id === transferId && f.type === "receipt"
  );

  /**
   * PDF stream reader / download functionality
   * @param {*} pdfUrl String
   */
  const openPdf = async (pdfUrl) => {
    const [err, data] = await asyncWrapper(downloadPdfPromise(pdfUrl));

    if (err) {
      return;
    }

    const file = new Blob([data], { type: "application/pdf" });
    const fileURL = URL.createObjectURL(file);
    window.open(fileURL);
  };

  return (
    <React.Fragment>
      {escrowAgreements.length > 0 &&
        !shouldHideDocuments(status) &&
        escrowAgreements.map((m) => {
          return (
            <div
              className="transfer-history__item-pdf"
              key={m.id}
              style={{ marginBottom: "5px" }}
            >
              <i
                className="far fa-file-pdf transfer-history__pdf-icon"
                style={{ marginRight: "5px" }}
              />
              <a
                href={m.fileURL}
                target="_blank"
                rel="noopener noreferrer"
                className="paymints__link"
              >
                View Escrow Agreement
              </a>
            </div>
          );
        })}
      {receipts.length > 0 &&
        !shouldHideDocuments(status) &&
        receipts.map((m) => {
          return (
            <div
              className="transfer-history__item-pdf"
              key={m.id}
              onClick={() => openPdf(m.fileURL)}
              style={{ marginBottom: "5px" }}
            >
              <i
                className="far fa-file-pdf transfer-history__pdf-icon"
                style={{ marginRight: "5px" }}
              />
              <a
                href={m.fileURL}
                target="_blank"
                rel="noopener noreferrer"
                className="paymints__link"
              >
                View Receipt
              </a>
            </div>
          );
        })}
    </React.Fragment>
  );
};

export default TransferDocuments;
